var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"flex-column caption",attrs:{"app":"","absolute":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }